import CDN_BASE from '../../utils/cdn';

// Verbatim move of the legacy PORTLAND_LOGOS array from LogoList.jsx.
// Portland has no residential / breweries / community / premiumPromo
// overrides yet — the `pickSlot` fallback in LogoList.jsx returns
// `common` for missing slots.
const common = [
  { src: `${CDN_BASE}/logos/Adidas.webp`, alt: 'Adidas' },
  { src: `${CDN_BASE}/logos/Airbnb.webp`, alt: 'Airbnb' },
  { src: `${CDN_BASE}/logos/BoeingLogo.webp`, alt: 'Boeing' },
  { src: `${CDN_BASE}/logos/ColumbiaSportsWear.webp`, alt: 'Columbia Sportswear' },
  { src: `${CDN_BASE}/logos/IntelLogo.webp`, alt: 'Intel' },
  { src: `${CDN_BASE}/logos/NikeLogo.webp`, alt: 'Nike' },
  { src: `${CDN_BASE}/logos/USBank.webp`, alt: 'US Bank' },
  { src: `${CDN_BASE}/logos/YahooLogo.webp`, alt: 'Yahoo' },
];

export default { common };
